/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLoginReward.vue?vue&type=template&id=8ffe042e&scoped=true"
import script from "./popLoginReward.vue?vue&type=script&lang=js"
export * from "./popLoginReward.vue?vue&type=script&lang=js"
import style0 from "./popLoginReward.vue?vue&type=style&index=0&id=8ffe042e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffe042e",
  null
  
)

export default component.exports